import * as React from "react";
function SvgSearch(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.036 15.306l5.707 5.47 1.414-1.356-5.707-5.47c2.055-2.627 1.836-6.37-.657-8.76-2.734-2.62-7.166-2.62-9.9 0-2.733 2.62-2.733 6.867 0 9.487 2.494 2.39 6.4 2.6 9.143.63zM13.4 13.3l-.046.044c-1.954 1.85-5.103 1.842-7.048-.022a4.652 4.652 0 010-6.776c1.953-1.871 5.119-1.871 7.072 0a4.651 4.651 0 01.022 6.754z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgSearch);
export default ForwardRef;
